import { configureStore } from '@reduxjs/toolkit';
import progressSlice from './progressSlice';
import coursesSlice from './coursesSlice';
import uiSlice from './uiSlice';

export const store = configureStore({
  reducer: {
    progress: progressSlice,
    courses: coursesSlice,
    ui: uiSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
